/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_NumberInputs */

const en_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUMBER`)
};

const fr_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUMERO`)
};

const de_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUMMER`)
};

const it_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUMERO`)
};

const ru_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЧИСЛО`)
};

const es_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÚMERO`)
};

const zh_cn2_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字`)
};

const ja_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番号`)
};

const hi_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संख्या`)
};

const pt_pt2_ccsl_export_header_number = /** @type {(inputs: Ccsl_Export_Header_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NÚMERO`)
};

/**
* | output |
* | --- |
* | "NUMBER" |
*
* @param {Ccsl_Export_Header_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_number = /** @type {((inputs?: Ccsl_Export_Header_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_number(inputs)
	if (locale === "de") return de_ccsl_export_header_number(inputs)
	if (locale === "it") return it_ccsl_export_header_number(inputs)
	if (locale === "ru") return ru_ccsl_export_header_number(inputs)
	if (locale === "es") return es_ccsl_export_header_number(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_number(inputs)
	if (locale === "ja") return ja_ccsl_export_header_number(inputs)
	if (locale === "hi") return hi_ccsl_export_header_number(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_number(inputs)
	return en_ccsl_export_header_number(inputs)
});